module.exports = __webpack_public_path__ + "img/oauth-success.721a18e3.jpg";